import { memo } from "react";

function VirtualStopMarker({
  stopNo,
  borderColor,
  backgroundColor = "#E5A70D",
}) {
  const shiftLeft = stopNo && stopNo < 10 ? 0 : -2;
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.5"
        y="4.5"
        width="23"
        height="23"
        rx="1.5"
        fill={backgroundColor}
      />
      <path
        d="M12.4375 18.1582H11.0078L10.709 12.4336H12.7363L12.4375 18.1582ZM10.6855 20.1621C10.6855 19.834 10.7734 19.5859 10.9492 19.418C11.125 19.25 11.3809 19.166 11.7168 19.166C12.041 19.166 12.291 19.252 12.4668 19.4238C12.6465 19.5957 12.7363 19.8418 12.7363 20.1621C12.7363 20.4707 12.6465 20.7148 12.4668 20.8945C12.2871 21.0703 12.0371 21.1582 11.7168 21.1582C11.3887 21.1582 11.1348 21.0723 10.9551 20.9004C10.7754 20.7246 10.6855 20.4785 10.6855 20.1621Z"
        fill={borderColor || "white"}
      />
      <rect
        x="0.5"
        y="4.5"
        width="23"
        height="23"
        rx="1.5"
        stroke={borderColor || "white"}
      />
      <rect x="15.5" y="0.5" width="13" height="13" rx="6.5" fill="#E5A70D" />
      <rect x="15.5" y="0.5" width="13" height="13" rx="6.5" stroke={borderColor || "white"} />

      <text
        id={2}
        fontFamily="OpenSans-SemiBold, Open Sans"
        fontSize={8}
        fontWeight={500}
        fill={borderColor || "white"}
      >
        <tspan x={20 + shiftLeft} y={10.5}>
          {stopNo}
        </tspan>
      </text>
    </svg>
  );
}

export default memo(VirtualStopMarker);
